<template>
    <div class="box-visual-wrapper w-100 d-flex justify-content-center">
        <div class="box-container" :class="boxClass">
            <!-- Tercio 0 -->
            <div class="box-third"
                :class="thirdClass(0)"
                @click="$emit('select-third', 0)"
                role="button"
            >
                <div class="third-content" v-if="thirds[0].product">
                    <div class="third-items d-flex justify-content-center align-items-center">
                        <img v-for="n in 3" :key="n" :src="products[thirds[0].product].image" :alt="products[thirds[0].product].name" class="item-img">
                    </div>
                    <span class="third-label">{{ products[thirds[0].product].name }} {{ variantLabel(thirds[0].variant) }}</span>
                    <button class="btn-remove" @click.stop="$emit('remove-third', 0)">✕</button>
                </div>
                <div class="third-empty d-flex justify-content-center align-items-center" v-else>
                    <span class="empty-label">{{ emptyLabel(0) }}</span>
                </div>
            </div>

            <!-- Divisor 0-1 -->
            <div class="box-divider" v-if="showDivider(0)"></div>

            <!-- Tercio 1 -->
            <div class="box-third"
                :class="thirdClass(1)"
                @click="$emit('select-third', 1)"
                role="button"
            >
                <div class="third-content" v-if="thirds[1].product">
                    <div class="third-items d-flex justify-content-center align-items-center">
                        <img v-for="n in 3" :key="n" :src="products[thirds[1].product].image" :alt="products[thirds[1].product].name" class="item-img">
                    </div>
                    <span class="third-label">{{ products[thirds[1].product].name }} {{ variantLabel(thirds[1].variant) }}</span>
                    <button class="btn-remove" @click.stop="$emit('remove-third', 1)">✕</button>
                </div>
                <div class="third-empty d-flex justify-content-center align-items-center" v-else>
                    <span class="empty-label">{{ emptyLabel(1) }}</span>
                </div>
            </div>

            <!-- Divisor 1-2 -->
            <div class="box-divider" v-if="showDivider(1)"></div>

            <!-- Tercio 2 -->
            <div class="box-third"
                :class="thirdClass(2)"
                @click="$emit('select-third', 2)"
                role="button"
            >
                <div class="third-content" v-if="thirds[2].product">
                    <div class="third-items d-flex justify-content-center align-items-center">
                        <img v-for="n in 3" :key="n" :src="products[thirds[2].product].image" :alt="products[thirds[2].product].name" class="item-img">
                    </div>
                    <span class="third-label">{{ products[thirds[2].product].name }} {{ variantLabel(thirds[2].variant) }}</span>
                    <button class="btn-remove" @click.stop="$emit('remove-third', 2)">✕</button>
                </div>
                <div class="third-empty d-flex justify-content-center align-items-center" v-else>
                    <span class="empty-label">{{ emptyLabel(2) }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BoxVisual',
    emits: ['select-third', 'remove-third'],
    props: {
        thirds: { type: Array, required: true },
        products: { type: Object, required: true },
    },
    computed: {
        boxClass() {
            const filled = this.thirds.filter(t => t.product !== null).length;
            if (filled === 3) return 'box-complete';
            if (filled > 0) return 'box-partial';
            return 'box-empty';
        },
    },
    methods: {
        thirdClass(index) {
            const t = this.thirds[index];
            let cls = '';
            if (t.product) {
                cls += ' filled';
                if (t.variant === 'spicy') cls += ' spicy';
            } else {
                cls += ' empty';
            }
            return cls;
        },
        showDivider(afterIndex) {
            const a = this.thirds[afterIndex];
            const b = this.thirds[afterIndex + 1];
            if (!a.product && !b.product) return false;
            if (a.product === b.product && a.variant === b.variant) return false;
            return true;
        },
        variantLabel(variant) {
            return variant === 'spicy' ? '🌶️' : '';
        },
        emptyLabel(index) {
            const filled = this.thirds.filter(t => t.product !== null).length;
            if (filled === 0 && index === 0) return 'Toca para empezar';
            return '+';
        },
    },
};
</script>

<style scoped>
.box-container {
    width: 100%;
    max-width: 340px;
    background: linear-gradient(145deg, #f5f0eb, #e8ddd3);
    border-radius: 16px;
    border: 3px solid #d4c4b0;
    overflow: hidden;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.5);
    transition: all 0.3s ease;
}

.box-container.box-complete {
    border-color: var(--primary);
    box-shadow: 0 8px 30px rgba(232, 118, 43, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.5);
    animation: boxComplete 0.5s ease;
}

@keyframes boxComplete {
    0%, 100% { transform: scale(1); }
    30% { transform: scale(1.02); }
    60% { transform: scale(0.99); }
}

.box-third {
    position: relative;
    min-height: 100px;
    padding: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.box-third.empty {
    background: rgba(255, 255, 255, 0.3);
}

.box-third.empty:hover {
    background: rgba(232, 118, 43, 0.08);
}

.box-third.filled {
    background: rgba(255, 255, 255, 0.6);
    animation: fillThird 0.4s ease;
}

.box-third.filled.spicy {
    background: rgba(220, 60, 30, 0.06);
}

@keyframes fillThird {
    0% { opacity: 0; transform: scale(0.9); }
    60% { transform: scale(1.02); }
    100% { opacity: 1; transform: scale(1); }
}

.box-divider {
    height: 2px;
    background: linear-gradient(90deg, transparent, #c4a882, transparent);
    margin: 0 12px;
    animation: dividerAppear 0.3s ease;
}

@keyframes dividerAppear {
    0% { opacity: 0; transform: scaleX(0); }
    100% { opacity: 1; transform: scaleX(1); }
}

.third-content {
    position: relative;
}

.third-items {
    gap: 8px;
}

.item-img {
    width: 80px;
    height: 60px;
    object-fit: contain;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));
    transition: transform 0.2s ease;
}

.box-third:hover .item-img {
    transform: scale(1.05);
}

.third-label {
    display: block;
    text-align: center;
    font-size: 12px;
    font-weight: 600;
    color: var(--text9);
    margin-top: 4px;
}

.btn-remove {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: none;
    background: rgba(0, 0, 0, 0.15);
    color: #fff;
    font-size: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease;
    line-height: 1;
}

.btn-remove:hover {
    background: rgba(220, 50, 50, 0.7);
}

.third-empty {
    min-height: 76px;
}

.empty-label {
    color: var(--text15);
    font-size: 14px;
    font-weight: 500;
}

.box-third.empty .empty-label {
    font-size: 24px;
    color: var(--text15);
}

.box-third.empty:first-child .empty-label {
    font-size: 14px;
}
</style>
